module.exports = "/_next/static/images/web-portal-7058c5d1c16c02c9c9e7afd7f58388b5.png";